const openButton = document.querySelector('.js-info-button');
const container = document.querySelector('.js-info-container');
const closeButton = document.querySelector('.js-info-close');

const openInfo = () => {
  openButton.classList.add('hidden');
  container.classList.remove('hidden');

  setTimeout(() => {
    container.classList.remove('translate-x-full');
  }, 10);
  document.body.classList.add('overflow-hidden');
};

const closeInfo = () => {
  container.classList.add('translate-x-full');
  document.body.classList.remove('overflow-hidden');

  setTimeout(() => {
    container.classList.add('hidden');
    openButton.classList.remove('hidden');
  }, 500);
};

const toggleInfo = () => {
  if (container.classList.contains('hidden')) {
    openInfo();
  } else {
    closeInfo();
  }
};

const events = () => {
  [openButton, closeButton].forEach(
    (el) => el.addEventListener('click', () => toggleInfo()),
  );
};

const init = () => {
  if (container) {
    events();
  }
};

export default {
  init,
};
